module.exports = "/_next/static/images/window_maximize-f575bc16da3356b64c47d9b87de88daa.svg";